import { render, staticRenderFns } from "./ProfInterestsPanel.vue?vue&type=template&id=17cc9d1a&scoped=true"
import script from "./ProfInterestsPanel.vue?vue&type=script&lang=js"
export * from "./ProfInterestsPanel.vue?vue&type=script&lang=js"
import style0 from "./ProfInterestsPanel.vue?vue&type=style&index=0&id=17cc9d1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17cc9d1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDataTable,VExpansionPanelContent,VSimpleCheckbox,VTextField})
